var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-container-base"},[_c('textarea',{staticClass:"text-area",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }